<div mat-dialog-content>

    <p *ngIf="data ==='La date est invalide'">{{ 'ERREURDATE.INVALIDEDATE' | translate }}</p>
    <p *ngIf="data ==='Heure déjà passée, sélectionnez une nouvelle heure'">{{ 'ERREURDATE.OLDDATE' | translate }}</p>

</div>
   
   
<div class="row justify-content-center" >
    <button mat-stroked-button class="activebtn" color="primary"     (click)="onConfirm()">{{ 'ERREURDATE.BOUTONOK' | translate }}</button>
</div>
